import { palette } from '../theme';

export const colorStatus = {
    active: {
        color: palette.success[800],
        background: palette.success[200]
    },
    recovery: {
        color: palette.tertiary[800],
        background: palette.tertiary[200]
    },
    inactive: {
        color: palette.disabled[800],
        background: palette.disabled[200]
    },
    blocked: {
        color: palette.error[800],
        background: palette.error[200],
    }
};
